export const NAME = 'pros';


// WEBPACK FOOTER //
// ./src/modules/pros/constants.js